<template>
  <div class="layout-selection-container" v-on-clickaway="hideLayoutMenu">
    <v-tooltip bottom color="primary" open-delay="100">
      <template v-slot:activator="{ on }">
        <v-btn
          text
          icon
          height="38"
          width="28"
          v-on="on"
          class="ma-0"
          @click="layoutMenuOpen = !layoutMenuOpen"
        >
          <v-icon color="#767676">view_compact</v-icon>
        </v-btn>
      </template>
      <span style="font-size: 9px">{{ $t("SplitScreen") }}</span>
    </v-tooltip>

    <div v-show="layoutMenuOpen">
      <div class="layout-selection-menu">
        <LayoutOneSVG
          @click.stop="setActiveLayout(1)"
          class="layout-icon layout-1"
        />

        <LayoutTwoSVG
          @click.stop="setActiveLayout(2)"
          class="layout-icon layout-2"
          :class="{ disabledLayout: nrOfOpenTabs < 2 }"
        />

        <LayoutThreeSVG
          @click.stop="setActiveLayout(3)"
          class="layout-icon layout-3"
          :class="{ disabledLayout: nrOfOpenTabs < 3 }"
        />

        <LayoutFourSVG
          @click.stop="setActiveLayout(4)"
          class="layout-icon layout-4"
          :class="{ disabledLayout: nrOfOpenTabs < 4 }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mixin as clickaway } from "vue-clickaway";
import LayoutSelectionSVG from "@/assets/home/layoutIcons/layoutSelectionButton.svg";
import LayoutOneSVG from "@/assets/home/layoutIcons/layoutOne.svg";
import LayoutTwoSVG from "@/assets/home/layoutIcons/layoutTwo.svg";
import LayoutThreeSVG from "@/assets/home/layoutIcons/layoutThree.svg";
import LayoutFourSVG from "@/assets/home/layoutIcons/layoutFour.svg";

export default {
  name: "HomeLayoutSelection",

  components: {
    LayoutSelectionSVG,
    LayoutOneSVG,
    LayoutTwoSVG,
    LayoutThreeSVG,
    LayoutFourSVG
  },

  mixins: [clickaway, checkPermissionsMixin],

  data() {
    return {
      nrOfOpenTabs: 1,
      /** Defines if the Layout menu is open or not */
      layoutMenuOpen: false,
      /** Currently active layout mode or number of tabs opened side by side. */
      activeLayout: 1,
      /** Object containing the info of the tab currently in the 2nd space (layout mode 2 to 4) */
      space2Tab: null,
      /** Object containing the info of the tab currently in the 3rd space (layout mode 3 to 4) */
      space3Tab: null,
      /** Object containing the info of the tab currently in the 4th space (layout mode 4) */
      space4Tab: null
    };
  },

  mounted() {
    bus.$on("updateOpenTabs", newValue => {
      this.nrOfOpenTabs = newValue.length;
    });
  },

  methods: {
    /** Hides the layout menu **/
    hideLayoutMenu() {
      this.layoutMenuOpen = false;
    },
    /**
     * Changed the active layout to the one selected.
     * @param {number} layout - number of the layout to activate.
     */
    setActiveLayout(layout) {
      if (this.nrOfOpenTabs >= layout) {
        this.activeLayout = layout;
        bus.$emit("updateActiveLayout", layout);
        if (layout > 1) {
          bus.$emit("enable-sidebar");
        }
        this.hideLayoutMenu();
      }
    }
  },

  destroyed() {
    bus.$off("updateOpenTabs");
  }
};
</script>

<style scoped>
.layout-selection-container {
  cursor: pointer;
  position: relative;
  width: 30px;
  height: 38px;
  margin-right: 10px;
}

.layout-selection-icon {
  height: 100%;
}

.layout-selection-menu {
  z-index: 5;
  width: 72px;
  height: fit-content;
  padding: 2px;
  background-color: #dcdcdd;
  cursor: default;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
}

.layout-selection-menu > * > * {
  fill: white !important;
}

.layout-icon {
  width: 31px;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  transition: 0.1s;
}

.layout-icon:hover {
  background-color: rgb(186, 185, 185);
}

.layout-1,
.layout-2 {
  left: 1px;
}

.layout-3,
.layout-4 {
  top: -4px;
  left: 1px;
}

.activeLayout,
.disabledLayout {
  cursor: default;
  pointer-events: none;
}

.disabledLayout path {
  fill: rgb(158, 159, 159) !important;
}

.activeLayout > rect {
  fill: rgb(241, 240, 240) !important;
}

.activeLayout:hover,
.disabledLayout:hover {
  background-color: #dcdcdd;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/NavBar/LayoutSelection.vue